import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import AlertsContent from "@/components/AlertsContent";
import AlertsSidebar from "@/components/AlertsSidebar";
import AlertsDetails from "@/components/AlertsDetails";
import DashboardMixin from '@/mixins/DashboardMixin';
export default {
  name: "AlertsPage",
  mixins: [DashboardMixin],
  components: {
    AlertsContent,
    AlertsSidebar,
    AlertsDetails
  },
  data() {
    return {
      dataLoading: true,
      selectedId: null,
      selectedRowId: null,
      selectedLevel: null,
      selectedType: null,
      sidebarOpen: false,
      detailsOpen: false,
      expandData: {
        rowId: null,
        tab: null
      }
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      accounts_list: state => state.account.list,
      me: state => state.auth.me,
      alerts: state => state.alerts.list,
      current_workspace: state => state.workspace.current_workspace,
      assignees: state => state.alerts.assignees
    }),
    ...mapGetters(["workspaceCurrent"])
  },
  async mounted() {
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      const accountIds = this.accounts_list.map(item => item.account_id);
      if (accountIds.length > 0) {
        await this.assigneesList({
          workspace_id: this.current_workspace.workspace_id
        });
        let result;
        result = await this.alertsList({
          seller_list: accountIds
        });
        result = await this.alertsListFromPostGres({
          seller_list: accountIds
        });
      }
      this.dataLoading = false;
    }
  },
  methods: {
    ...mapActions(["authStatus", "alertsList", "alertsListFromPostGres", "updatingAlertingStatus", "assigneesList", "workspaceList"]),
    onToggleSelect(data) {
      this.selectedRowId = this.selectedRowId === data.id && this.selectedLevel === data.level ? null : data.id;
      this.selectedLevel = data.level;
      this.selectedType = data.type;
      this.sidebarOpen = this.selectedRowId !== null;
    },
    onToggleId(id) {
      this.selectedId = this.selectedId === id ? null : id;
      this.detailsOpen = this.selectedId !== null;
    },
    onSidebarClose() {
      if (!this.detailsOpen) {
        this.selectedRowId = null;
      }
      this.sidebarOpen = false;
    },
    onSelectId(data) {
      this.selectedId = this.selectedId === data.id ? null : data.id;
      this.selectedRowId = data.rowId;
    },
    async onAssigneeChange(newAssignee, selectedData) {
      const formatted = this.formatForBackendPayload(selectedData, {
        assignee: newAssignee.name
      });
      await this.sendAlertUpdate(formatted);
    },
    async onStatusChange(newStatus, selectedData) {
      const formatted = this.formatForBackendPayload(selectedData, {
        status: newStatus
      });
      await this.sendAlertUpdate(formatted);
    },
    async sendAlertUpdate(payloadItem) {
      const payload = {
        alert_status_list: [payloadItem]
      };
      try {
        this.dataLoading = true;
        let data = await this.$store.dispatch("updatingAlertingStatus", payload);
        if (data.count) {
          window.$bus.trigger("showSuccess", {
            visible: true,
            message: data.status
          });
        }
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: "Error updating the result. " + error,
          visible: true,
          delay: 10
        });
      } finally {
        this.dataLoading = false;
      }
    },
    formatForBackendPayload(selectedId, overrides = {}) {
      return {
        seller_id: selectedId.seller_id,
        sku: selectedId.sku,
        asin: selectedId.asin,
        marketplace_id: selectedId.marketplace_id,
        country_code: selectedId.country_code || '',
        amazon_link: selectedId.amazon_link || '',
        main_image_link: selectedId.main_image_link || '',
        standardized_main_image_link: selectedId.standardized_main_image_link || '',
        standardized_product_name: selectedId.standardized_product_name || '',
        product_title_amazon: selectedId.product_title_amazon || '',
        alerting_category: selectedId.alerting_category,
        alerting_type: selectedId.alerting_type,
        alerting_message: selectedId.alerting_message,
        alert_priority: selectedId.alert_priority || '',
        alert_id: selectedId.id,
        assignee: overrides.assignee ?? selectedId.assignee?.name,
        status: overrides.status ?? selectedId.status,
        created_at: selectedId.created_at,
        last_modified: moment().format("YYYY_MM_DD").toString()
      };
    },
    onDetailsClose() {
      this.selectedId = null;
      this.detailsOpen = false;
    },
    onExpand(data) {
      this.expandData = data;
    }
  }
};